module.exports = __webpack_public_path__ + "img/4.28e6dffe.png";